import { configureStore } from "@reduxjs/toolkit"
import settingsReducer from "./features/settings/settingsSlice"
import scheduleReducer from "./features/schedule/scheduleSlice"
import futureSchedulesReducer from "./features/futureHuddles/futureSchedulesSlice"
import sandboxReducer from "./features/schedule/sandboxSlice"
import userReducer from "./features/users/userSlice"
import tomorrowReducer from "./features/schedule/tomorrowSlice"

const store = configureStore({
	reducer: {
		settings: settingsReducer,
		schedule: scheduleReducer,
		sandbox: sandboxReducer,
		tomorrow: tomorrowReducer,
		futureSchedules: futureSchedulesReducer,
		user: userReducer
	}
})

export default store
